import { createApp } from 'vue'
import App from './App.vue'
import { clickOutsideDirective } from './directives/click-outside'
import './registerServiceWorker'
import { key, store } from './store'

createApp(App).use(store, key).directive('click-outside', clickOutsideDirective).mount('#app')
